// src/hooks/useFileActionHandler.ts
import { useCallback } from 'react';
import { FileNode, FileActionDispatch } from '../types/FileManagerTypes';
import { FileAction } from '../enums/fileActions';

type FilesArg = FileNode[] | undefined;

export const useFileActionHandler = (
  handleBulkDownload: (files: FileNode[]) => void,
  showReupload: (files?: FilesArg) => void,
  showPreview: (files?: FilesArg) => void,
  showMove: (files?: FilesArg) => void,
  showTrashConfirmation: (files?: FilesArg) => void,
  showRestoreTrash: (files?: FilesArg) => void,
  showDeleteConfirmation: (files?: FilesArg) => void,
  showPermissions: (files?: FilesArg) => void,
  createImageLayer: (imageId: FileNode[]) => void,
  removeImageLayer: (imageId: FileNode[]) => void,
  handleFileSelection: (files: FileNode[]) => void,
): FileActionDispatch => {
  return useCallback(
    (actionId, files) => {
      const actionMap: Partial<Record<FileAction, (files: FileNode[]) => void>> = {
        [FileAction.CREATE_IMAGE_LAYER]: createImageLayer,
        [FileAction.REMOVE_IMAGE_LAYER]: removeImageLayer,
        [FileAction.DELETE_FILES]: showTrashConfirmation,
        [FileAction.DELETE_ALL]: showTrashConfirmation,
        [FileAction.REUPLOAD_FILE]: showReupload,
        [FileAction.PREVIEW_FILE]: showPreview,
        [FileAction.MOVE_FILE]: showMove,
        [FileAction.MOVE_ALL]: showMove,
        [FileAction.RESTORE_FILE]: showRestoreTrash,
        [FileAction.RESTORE_ALL]: showRestoreTrash,
        [FileAction.PERMANENTLY_DELETE_FILE]: showDeleteConfirmation,
        [FileAction.PERMANENTLY_DELETE_ALL]: showDeleteConfirmation,
        [FileAction.DOWNLOAD_FILES]: handleBulkDownload,
        [FileAction.DOWNLOAD_ALL]: handleBulkDownload,
        [FileAction.CHANGE_SELECTION]: handleFileSelection,
        [FileAction.FILE_PERMISSIONS]: showPermissions,
      };

      actionMap[actionId as FileAction]?.(files);
    },
    [
      createImageLayer,
      removeImageLayer,
      handleFileSelection,
      showReupload,
      showPreview,
      showMove,
      showTrashConfirmation,
      showRestoreTrash,
      showDeleteConfirmation,
      showPermissions,
      handleBulkDownload,
    ],
  );
};
